import { ON_CHANGE_GAME_DOWN, ON_CHANGE_GAME_UP } from '../state-constants/stateConstants';

export const onChangeGameUp = (level) => ({
  type: ON_CHANGE_GAME_UP,
  payload: level,
});

export const onChangeGameDown = (level) => ({
  type: ON_CHANGE_GAME_DOWN,
  payload: level,
});


// WEBPACK FOOTER //
// ./src/state-actions/onChangeGameLevel.js